<template>
  <div class="item-activity">
    <p :class="isShop ? 'shop-tag activity' : 'activity'">
      <i v-if="isShop" class="icon-outlined_store"></i>
      <span>{{ text.content }}</span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'Tag',
  props: {
    text: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  computed: {
    isShop() {
      return this.text?.tagImg === 'customer_img_shop_coupon_tag';
    },
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss">
.item-activity {
  display: inline-block;
  margin-right: 5px;
  line-height: 0;
  margin-bottom: 2px;
  .activity {
    position: relative;
    display: inline-block;
    margin: 0 8px;
    @include act-tag-bg-color();
    box-sizing: border-box;
    @include font-color();
    font-weight: 200;
    span {
      font-family: 'Aspira Regular';
      font-weight: 400;
      font-size: 12px;
      line-height: 22px;
      @include text-overflow();
      width: 100%;
      display: inline-block;
    }
    &::before,
    &::after {
      content: '';
      display: block;
      height: 100%;
      width: 8px;
      position: absolute;
      top: 0;
      z-index: 1;
    }
    &::before {
      right: 100%;
      @include activity-tag-bg-left();
    }
    &::after {
      left: 100%;
      @include activity-tag-bg-right();
    }
  }
  .shop-tag {
    position: relative;
    .icon-outlined_store {
      color: #fff;
      font-size: 16px;
      position: absolute;
      left: -2px;
      z-index: 1;
      top: 10px;
      line-height: 0;
    }
    &::before {
      width: 26px;
    }
    &::before {
      left: -8px;
      @include activity-tag-left();
    }
    span {
      display: inline-block;
      text-indent: 24px;
    }
  }
}
@media screen and (max-width: 768px) {
  .item-activity {
    .activity {
      span {
        font-size: rem(22);
        line-height: rem(42);
      }
    }
    .shop-tag {
      .icon-outlined_store {
        font-size: rem(28);
        left: rem(-1);
        top: rem(21);
      }
      &::before {
        width: rem(52);
      }
      span {
        text-indent: rem(44);
      }
    }
  }
}
</style>